import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProductBasicInfo from "../../commponents/product/productBasicInfo";
import ProductGallery from "../../commponents/product/productGallery";
import ProductDescriptionList from "../../commponents/product/productDescriptionList";
import { getProductById } from "../../api/productApi";
import AdminLayout from "../../commponents/layout/adminLayout";
import { showError } from "../../utils/ alert";




interface ProductCategory {
  id: number;
  name: string;
}

interface ProductImage {
  id: number;
  image: string;
}

interface ProductDescription {
  id: number;
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface ProductDetailResponse {
  id: number;
  name: string;
  slug: string;
  category: ProductCategory;
  subCategory: ProductCategory;
  status: boolean;
  createdAt?: string;
  updatedAt?: string;
  productImages: ProductImage[];
  productDemoImages: ProductImage[];
  descriptions: ProductDescription[];
}

export default function ProductDetail() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [product, setProduct] = useState<ProductDetailResponse | null>(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchProduct(Number(id));
    }
  }, [id]);

  const fetchProduct = async (id: number) => {
    try {
      setLoading(true);

      const response = await getProductById(id);

      setProduct(response.data.data);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex h-80 items-center justify-center">Loading...</div>
    );
  }

  if (!product) {
    return (
      <div className="flex h-80 items-center justify-center">
        Product Not Found
      </div>
    );
  }

  const createdAt = product.createdAt
    ? new Date(product.createdAt).toLocaleString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

  const updatedAt = product.updatedAt
    ? new Date(product.updatedAt).toLocaleString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

  

  return (
    <AdminLayout>
      <div className="space-y-8">
        {/* Header */}

        {/* Basic Information */}
        <ProductBasicInfo
          id={product.id}
          name={product.name}
          category={product.category}
          subCategory={product.subCategory}
          status={product.status}
          createdAt={createdAt}
          updatedAt={updatedAt}
          onEdit={() => navigate(`/product/edit/${product.id}`)}
        />

        {/* Gallery */}
        <ProductGallery
          productImages={product.productImages}
          productDemoImages={product.productDemoImages}
        />

        {/* Specifications */}
        <ProductDescriptionList descriptions={product.descriptions} />
      </div>
    </AdminLayout>
  );
}
